(function () {
    'ngInject';

    angular.module('app.shared.services').service('MdDialogService', mdDialogService);

    function mdDialogService($mdDialog) {
        /**
         * @param {string} title mdDialog title
         * @param {string} msg mdDialog ok message
         */
        function showSuccessModal(title, msg) {
            $mdDialog.show($mdDialog.alert().parent(document.body).clickOutsideToClose(false).title(title).ok(msg));
        }

        /**
         * @param {string} title mdDialog title
         * @param {string} msg mdDialog textContent
         * @param {Object} error if it has an stack it will be appended to the textContent.
         * @param {Function} next Operation to be executed after the dialog closes.
         */
        function showCommonError(error, msg, title = 'Error!', next = function () {}) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title(title)
                        .textContent(msg + (error?.stack ? `: ${error.stack}` : ''))
                        .ok('OK!')
                )
                .then(function () {
                    next();
                });
        }

        /**
         * @param {string} imageFilterName image Filter name to be appended in the title and text content
         * @param {Object} error if isn't null, it will be displayed on the text content, otherwise a basic test will be displayed.
         */
        function showImageFilterError(imageFilterName, error) {
            $mdDialog.show(
                $mdDialog
                    .alert()
                    .parent(document.body)
                    .clickOutsideToClose(true)
                    .title(`${imageFilterName} Error!`)
                    .textContent(
                        error.msg ||
                            error ||
                            `There seems to be an error with your ${imageFilterName} account, so the filter could not be applied to the image.`
                    )
                    .ok('OK!')
            );
        }

        return {
            showSuccessModal: showSuccessModal,
            showCommonError: showCommonError,
            showImageFilterError: showImageFilterError
        };
    }
})();
